import styled from 'styled-components';

import theme from '$/assets/theme';

const ErrorMessage = styled.span`
  font-size: 14px;
  color: ${theme.colors.functionalRed};
  grid-column: span 2;
`;

export default ErrorMessage;
